import { post, get, put, deleteApi } from './axiosFun';
//当前用户待考试卷
export const todoExamPaper = () => { return get("/edu/exam/todoExamPaper") };

//考试参与
export const examJoin = (params) => { return post("/edu/exam/examJoin",params) };

//提交试卷
export const commitPaper = (params) => { return put("/edu/exam/commitPaper",params) };

// 查询当前参与中的考试
export const examJoinQuery = (examId) => { return get(`/edu/exam/examJoinQuery/${examId}`) };

// 考试结果详情
export const examResDetail = (examId) => { return get(`/edu/exam/examResDetail/${examId}`) };

// 考试统计分页
export const examStatPage = (params) => { return put(`/edu/exam/examStatPage`,params) };


// WEBPACK FOOTER //
// ./src/api/takeExam.js